import ReportTable from '../../../../../components/Grid/ReportTable';

export default function OperacoesTableAgrupada(props: any) {
  return <ReportTable model={props.model} columnCount={4} />;
}
